module.exports = __webpack_public_path__ + "assets/c_american-express-b52368.svg";